import { all, call, put, takeEvery } from "redux-saga/effects";
import {
  deleteList,
  deleteListArray,
  fetchAllLists,
  updateList,
} from "../../networking/lists/networking";
import * as types from "../types/lists";

function* fetchClientLists(action) {
  try {
    if (action.payload) {
      const response = yield call(fetchAllLists, action.payload);
      if (response.error === null) {
        yield put({ type: types.SET_LISTS_CONTENT, content: response.payload });
      } else {
        throw new Error({ error: "Kunne ikke hente lister" });
      }
    } else {
      throw new Error({ error: "Kunne ikke hente lister" });
    }
  } catch ({ error }) {
    yield put({ type: types.REVOKE_LISTS_CONTENT, message: error });
  }
}

function* performRemoveList(action) {
  try {
    if (action.details) {
      const response = yield call(deleteList, action.details);
      if (response.error === null) {
        yield put({ type: types.GRANT_DELETE_LIST });
        yield put({
          type: types.CHANGE_LISTS_MODALS,
          modal: { deleteModal: false },
        });
      } else {
        throw new Error({ error: "Kunne ikke slette liste." });
      }
    } else {
      throw new Error({ error: "Kunne ikke slette liste." });
    }
  } catch ({ error }) {
    yield put({ type: types.REVOKE_DELETE_LIST, message: error });
    yield put({
      type: types.CHANGE_LISTS_MODALS,
      modal: { deleteModal: false },
    });
  }
}

function* performUpdateList(action) {
  try {
    if (action.details) {
      const response = yield call(updateList, action.details);
      if (response.error === null) {
        yield put({ type: types.GRANT_UPDATE_LIST });
        yield put({
          type: types.CHANGE_LISTS_MODALS,
          modal: { editModal: false },
        });
      } else {
        throw new Error({ error: "Kunne ikke oppdatere liste." });
      }
    } else {
      throw new Error({ error: "Kunne ikke oppdatere liste." });
    }
  } catch ({ error }) {
    yield put({ type: types.REVOKE_UPDATE_LIST, message: error });
    yield put({ type: types.CHANGE_LISTS_MODALS, modal: { editModal: false } });
  }
}

function* performRemoveListArray(action) {
  try {
    if (action.details) {
      const response = yield call(deleteListArray, action.details);
      if (response.error === null) {
        yield put({ type: types.GRANT_DELETE_LIST_ARRAY });
      } else {
        throw new Error({ error: "Kunne ikke slette lister." });
      }
    } else {
      throw new Error({ error: "Kunne ikke slette lister." });
    }
  } catch ({ error }) {
    yield put({ type: types.REVOKE_DELETE_LIST_ARRAY, message: error });
  }
}

function* listsSaga() {
  yield all([
    takeEvery(types.REQUEST_LISTS_CONTENT, fetchClientLists),
    takeEvery(types.REQUEST_DELETE_LIST, performRemoveList),
    takeEvery(types.REQUEST_UPDATE_LIST, performUpdateList),
    takeEvery(types.REQUEST_DELETE_LIST_ARRAY, performRemoveListArray),
  ]);
}

export default listsSaga;
